var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    {
      attrs: {
        width: 322,
        height: 205,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb",
      },
    },
    [
      _c("rect", {
        attrs: { height: "4", width: "42", y: "10.45313", x: "12.5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "19", width: "293", y: "19.45313", x: "12.5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "4", width: "42", y: "55.45313", x: "12.5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "19", width: "293", y: "64.45313", x: "12.5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "4", width: "42", y: "106.45313", x: "12.5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "19", width: "293", y: "115.45313", x: "12.5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "4", width: "42", y: "158.45313", x: "12.5" },
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { height: "19", width: "293", y: "167.45313", x: "12.5" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }